import { toMatNewSchoolInput } from '../../../utils/schoolFormMapper';
import { isNewSchoolRow, isExistingLink } from './schoolsListUtils';

// Pure builder for the addMatGroup request body. Kept side-effect free so the whole
// contract — director defaulting/login, GUID trimming, ISO dates, the MatSchoolIds vs
// MatNewSchools split and the subscription block — is unit-testable in isolation.

const toIsoDate = (value) => (value ? new Date(value).toISOString().split('T')[0] : null);

const toNumber = (value, fallback = 0) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};

export const buildAddMatGroupPayload = (values, schools = []) => {
  const groupName = values.GroupName || '';

  // Links go into MatSchoolIds: an attached existing Welbee school by its DB id, an
  // unedited GIAS pick by its URN (the backend resolves either).
  const matSchoolIds = schools
    .filter(isExistingLink)
    .map((row) => (row.source === 'existing' ? row.existingId : parseInt(row.values.Urn, 10)))
    .filter((value) => value !== null && value !== undefined && !Number.isNaN(value));

  const matNewSchools = schools
    .filter(isNewSchoolRow)
    .map((row) => toMatNewSchoolInput(row.values));

  const guid = (values.MatGroupUID || '').trim();

  const payload = {
    Id: 0,
    Name: values.Name || '',
    FirstName: values.FirstName && values.FirstName.trim() !== '' ? values.FirstName : groupName,
    LastName: values.LastName && values.LastName.trim() !== '' ? values.LastName : groupName,
    GroupName: groupName,
    Group: values.Group || '',
    CustomGroup: values.CustomGroup || '',
    isTestAccount: values.isTestAccount || false,
    File: values.File || null,
    FileName: values.FileName || null,
    TrancateFileName: values.TrancateFileName || null,
    MatSchoolProducts: values.products || [],
    MatSchoolIds: matSchoolIds,
    MatNewSchools: matNewSchools,
    MatGroupUID: guid !== '' ? guid : null,
    GroupType: values.GroupType || '',
    GroupOpenDate: null,
    CustomerType: values.CustomerType || '',
    Country: values.Country || '',
    DataStorageLocation: values.DataStorageLocation || '',
    IsMATSubscription: values.IsMATSubscription !== undefined ? values.IsMATSubscription : true,
    IsMultiYear: values.IsMultiYear !== undefined ? values.IsMultiYear : false,
    IsAutoRenewal: values.IsAutoRenewal !== undefined ? values.IsAutoRenewal : true,
    SubscriptionTerm: values.SubscriptionTerm || 1,
    Year1Cost: toNumber(values.Year1Cost),
    Year2Cost: toNumber(values.Year2Cost),
    Year3Cost: toNumber(values.Year3Cost),
    VatPercentApplied: toNumber(values.VatPercentApplied, 20),
    Discount: toNumber(values.Discount),
    PaymentCurrency: 1,
    PaymentMode: values.PaymentMode || 1,
    StartDate: toIsoDate(values.StartDate),
    EndDate: toIsoDate(values.EndDate),
    RenewalDate: toIsoDate(values.RenewalDate),
  };

  // Optional director login. Only sent when provided, so a blank form behaves exactly as
  // before (the backend provisions a dummy director); when filled these carry the same
  // Email/Username the retired standalone group page posted.
  const email = (values.Email || '').trim();
  const username = (values.Username || '').trim();
  if (email) payload.Email = email;
  if (username) payload.Username = username;

  return payload;
};
